/* eslint-disable import/extensions */
import React from 'react'
import type {
    GroupByType,
    SwingTimingData,
} from 'leaderboard/scripts/swing-path/types/globals.ts'
import type { GroupByLogic } from './utils/do-group-by-logic.ts'
import MobilePlayerCardChart from './MobilePlayerCardChart.tsx'
import type { PitchTypeColorMode } from './utils/can-use-pitch-type-colors.ts'
import type SwingTimingChart from './swing-timing-chart.ts'
import { MAX_SWING_TIMING_SELECTIONS } from './utils/constants.ts'

type MobileLegendProps = {
    rows: SwingTimingData[]
    type: GroupByType
    pitchTypeColors: boolean
    pitchTypeColorMode: PitchTypeColorMode
    hoveredKey: string | null
    handleRemove: (row: SwingTimingData) => void
    groupByLogic: GroupByLogic
    charts: SwingTimingChart[]
}

export default function MobileLegend({
    rows,
    type,
    pitchTypeColors,
    pitchTypeColorMode,
    hoveredKey,
    handleRemove,
    groupByLogic,
    charts,
}: MobileLegendProps) {
    const isFull = rows.length >= MAX_SWING_TIMING_SELECTIONS
    return (
        <div className="swing-timing-mobile-legend">
            {rows.map((row) => (
                <MobilePlayerCardChart
                    key={row.uniqueId}
                    row={row}
                    type={type}
                    pitchTypeColors={pitchTypeColors}
                    pitchTypeColorMode={pitchTypeColorMode}
                    hoveredKey={hoveredKey}
                    handleRemove={handleRemove}
                    groupByLogic={groupByLogic}
                    charts={charts}
                />
            ))}
            {!isFull && (
                <button
                    type="button"
                    className="swing-timing-mobile-legend-add-button"
                    popovertarget="player-search"
                    aria-label="Add player"
                >
                    +
                </button>
            )}
        </div>
    )
}
